// extracted by mini-css-extract-plugin
export default {"page":"PageTransition_page__xddhR","pageEnter":"PageTransition_pageEnter__mrjEZ"};